import React, { useMemo } from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DynamicBreadcrumbs = ({ current, onHome, onPackages, onTags }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleHome = onHome || (() => navigate('/'));
  const handlePackages = onPackages || (() => navigate('/pkgs'));
  const handleTags = onTags || (() => navigate('/tags'));

  const routeLabels = {
    '/': 'Projects',
    '/pkgs': 'Packages',
    '/tags': 'Tag Workspace',
    '/config': 'Configurator',
    '/size': 'Size',
    '/config-detail': 'Configuration Details',
    '/permissions': 'Permissions',
    '/rev': 'Import',
    '/preference': 'General Settings',
  };

  const pageName = useMemo(() => {
    if (current) return current;
    return routeLabels[location.pathname] || 'Page';
  }, [current, location.pathname]);

  const crumbs = useMemo(() => {
    if (pageName === 'Projects') return [{ label: 'Projects' }];
    if (pageName === 'General Settings') {
      const from = location.state?.from;
      const fromLabel = from ? routeLabels[from] : null;
      const trail = [{ label: 'Projects', onClick: handleHome }];
      if (from && from !== '/') {
        if (from === '/pkgs' || from === '/tags' || from === '/config' || from === '/size' || from === '/config-detail' || from === '/rev' || from === '/permissions') {
          trail.push({ label: 'Packages', onClick: handlePackages });
        }
        if (from === '/tags' || from === '/config' || from === '/size' || from === '/config-detail') {
          trail.push({ label: 'Tag Workspace', onClick: handleTags });
        }
        if (fromLabel && !['Projects', 'Packages', 'Tag Workspace'].includes(fromLabel)) {
          trail.push({ label: fromLabel, onClick: () => navigate(from) });
        }
      }
      trail.push({ label: pageName });
      return trail;
    }
    if (pageName === 'Packages') return [{ label: 'Projects', onClick: handleHome }, { label: pageName }];
    if (pageName === 'Permissions' || pageName === 'Import') return [
      { label: 'Projects', onClick: handleHome },
      { label: 'Packages', onClick: handlePackages },
      { label: pageName },
    ];
    if (pageName === 'Tag Workspace') return [
      { label: 'Projects', onClick: handleHome },
      { label: 'Packages', onClick: handlePackages },
      { label: pageName },
    ];

    return [
      { label: 'Projects', onClick: handleHome },
      { label: 'Packages', onClick: handlePackages },
      { label: 'Tag Workspace', onClick: handleTags },
      { label: pageName },
    ];
  }, [handleHome, handlePackages, handleTags, location.pathname, location.state, navigate, pageName]);

  return (
    <Breadcrumbs separator={<></>} aria-label="breadcrumb" style={{ marginBottom: '-10px' }}>
      {crumbs.map((crumb, index) => (
        <Typography
          key={`${crumb.label}-${index}`}
          className="fntColor fs-12"
          onClick={crumb.onClick}
          sx={crumb.onClick ? { cursor: 'pointer' } : undefined}
        >
          {t(crumb.label)}
        </Typography>
      ))}
    </Breadcrumbs>
  );
};

export default DynamicBreadcrumbs;
